import { ApiClient } from '@webapp/core/services/ApiClient'
import { RequestRepository } from './RequestRepository'

export const requestRepository = new RequestRepository({
  httpClient: ApiClient,
})
